import React from "react";
import { TitleBlock, Field, SelectInput, Actions, PrimaryBtn } from "../../../../auth/v2/pieces";
import { NCAA_CONFERENCE_GROUPS } from "../../../../ForBusiness/Cacheshare/taxonomy";
import { useCascadeFields, optionLabel } from "../../../../ForBusiness/Cacheshare/hooks/useCascadeFields";
import LeagueCombobox from "../LeagueCombobox";

// 07 · League (optional; the topbar Skip goes straight to Team). The picked
// league may narrow further by circuit, by class (state associations) or by
// conference (NCAA); all optional. Coaches never see the data provider's
// name (D16).
const LeagueStep = ({ filters, onChange, onContinue }) => {
  const f = useCascadeFields(filters, onChange);
  const { body, subDivision, classDivision, conference } = filters;
  return (
    <>
      <TitleBlock eyebrow="League · optional" title="Which league is your team in?" sub="Optional. Skip to see all teams in this tier." />
      <Field label="League" hint="Search every league and event (state association, showcase, circuit)">
        <LeagueCombobox options={f.bodyOptions} gender={filters.gender?.value} value={body} onPick={(next) => onChange({ body: next })} />
      </Field>
      {f.showSubDivisionStep && (
        <Field label="League / Circuit" hint="Optional. Team search below always overrides.">
          <SelectInput aria-label="League / Circuit" value={subDivision?.value || ""} onChange={(e) => f.onSubDivision(e.target.value)}>
            <option value="">All {body.name} divisions</option>
            {f.subDivisionOptions.map((s) => (
              <option key={s.value} value={s.value} disabled={s.status !== "live"}>
                {optionLabel(s)}
              </option>
            ))}
          </SelectInput>
        </Field>
      )}
      {f.showClassStep && (
        <Field label="Class / Division" hint="Optional.">
          <SelectInput aria-label="Class / Division" value={classDivision?.value || ""} onChange={(e) => f.onClassDivision(e.target.value)}>
            <option value="">All classes</option>
            {f.classOptions.map((c) => (
              <option key={c.name} value={c.name}>
                {c.name}
              </option>
            ))}
          </SelectInput>
        </Field>
      )}
      {f.showConferenceStep && (
        <Field label="Conference" hint="Optional.">
          <SelectInput aria-label="Conference" value={conference?.value || ""} onChange={(e) => f.onConference(e.target.value)}>
            <option value="">All conferences</option>
            {NCAA_CONFERENCE_GROUPS.map((g) => (
              <optgroup key={g.label} label={g.label}>
                {g.options.map((c) => (
                  <option key={c.value} value={c.value}>
                    {c.name}
                  </option>
                ))}
              </optgroup>
            ))}
          </SelectInput>
        </Field>
      )}
      <Actions>
        <PrimaryBtn onClick={onContinue}>Continue</PrimaryBtn>
      </Actions>
    </>
  );
};

export default LeagueStep;
